import React from 'react';
import { Trans } from '@lingui/macro';

export default {
  billingAddress: <Trans id="billingAddress" />,
  birthdate: <Trans id="general.birthdate" />,
  birthplace: <Trans id="general.birthplace" />,
  clientType1: <Trans id="clientType1" />,
  clientType2: <Trans id="clientType2" />,
  companyAddress: <Trans id="general.companyAddress" />,
  companyInfo: <Trans id="companyInfo" />,
  companyName: <Trans id="general.companyName" />,
  companyRepresentative: <Trans id="companyRepresentative" />,
  email: <Trans id="general.email" />,
  example: <Trans id="general.car.model.example" />,
  female: <Trans id="general.female" />,
  firstName: <Trans id="general.firstName" />,
  gender: <Trans id="general.gender" />,
  language: <Trans id="general.language" />,
  lastName: <Trans id="general.lastName" />,
  make: <Trans id="general.car.make" />,
  male: <Trans id="general.male" />,
  model: <Trans id="general.car.model" />,
  phone: <Trans id="general.phoneNumber" />,
  plateNumber: <Trans id="general.car.plateNumber" />,
  policyholder: <Trans id="general.policyholder" />,
  sameAsLevalAddress: <Trans id="sameAsLevalAddress" />,
  vat: <Trans id="general.VATNumber" />,
  youAre: <Trans id="youAre" />,
  legalConsent: <Trans id="policyHolder.legalConsent" />,
  nationalRegisterNumber: <Trans id="general.nationalRegisterNumber" />,
};
